import { render, staticRenderFns } from "./StatisticsCardLine.vue?vue&type=template&id=b62b71e8&scoped=true"
import script from "./StatisticsCardLine.vue?vue&type=script&lang=js"
export * from "./StatisticsCardLine.vue?vue&type=script&lang=js"
import style0 from "./StatisticsCardLine.vue?vue&type=style&index=0&id=b62b71e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62b71e8",
  null
  
)

export default component.exports